module.exports = __webpack_public_path__ + "img/lg_ring_y_e_null_null@2x.3b0fe7b3.png";